export default "__VITE_PUBLIC_ASSET__8791aa49__"